// import React, { useEffect } from 'react';

// const GTranslateDropdown = () => {
//   const setLanguage = (lang) => {

//     console.log(lang)
//     sessionStorage.setItem('gamesbox-country-code', lang);


//     if (lang === 'en') {
//       deleteCookie('googtrans');
//       deleteCookie('googtrans', '/', window.location.hostname);
//     } else {
//       const value = `/en/${lang}`;
//       document.cookie = `googtrans=${value}; path=/`;
//       document.cookie = `googtrans=${value}; domain=${window.location.hostname}; path=/`;
//     }

//   };

//   const deleteCookie = (name, path = '/', domain) => {
//     document.cookie = `${name}=; path=${path}; ${domain ? `domain=${domain};` : ''} expires=Thu, 01 Jan 1970 00:00:01 GMT;`;
//   };


//   const dropdown = document.querySelector('.gt_selector.notranslate');


//   if (dropdown) {
//     dropdown.addEventListener('change', handleChange);
//   }
  
//     function handleChange(e) {
//       console.log('Selected item:', e.target.value);
//     }



//   useEffect(() => {



//     const countryCode = sessionStorage.getItem('gamesbox-country-code');
//     const default_lang_set = sessionStorage.getItem('default_lang_set');

//     if (countryCode) {
//       if (countryCode.toLowerCase() === 'fr') {
//         if (!default_lang_set) {
//           setLanguage('fr');
//           sessionStorage.setItem("default_lang_set", true)
//         }
//       }

//       if (countryCode.toLowerCase() === 'pl') {
//         if (!default_lang_set) {
//           setLanguage('pl');
//           sessionStorage.setItem("default_lang_set", true)
//         }
//       }

//     } else {
//       fetch('https://dz5yc9ggwa4v9.cloudfront.net/Lambda/GetCountry')
//         .then((response) => response.text())
//         .then((country) => {
//           const code = country.toLowerCase();
//           sessionStorage.setItem('gamesbox-country-code', code);
//           if (code === 'fr') {
//             setLanguage('fr');
//           }
//           if (code === 'pl') {
//             setLanguage('pl');
//           }
//         })
//         .catch((err) => {
//           console.warn('Failed to get country:', err);
//         });
//     }

//     // GTranslate widget settings
//     window.gtranslateSettings = {
//       default_language: 'en',
//       languages: ['en', 'de', 'ar', 'fr', 'pl'],
//       wrapper_selector: '.gtranslate_wrapper',
//     };

//     const script = document.createElement('script');
//     script.src = 'https://cdn.gtranslate.net/widgets/latest/dropdown.js';
//     script.defer = true;
//     document.body.appendChild(script);

//     return () => {
//       document.body.removeChild(script);
//     };
//   }, []);

//   return <div className="gtranslate_wrapper" />;
// };

// export default GTranslateDropdown;






import React, { useEffect, useState } from 'react';

const GTranslateDropdown = () => {
  const [selectedLang, setSelectedLang] = useState('en');

  const setLanguage = (lang) => {
    console.log('Selected language:', lang);
    setSelectedLang(lang);
    sessionStorage.setItem('gamesbox-country-code', lang);

    if (lang === 'en') {
      deleteCookie('googtrans');
      deleteCookie('googtrans', '/', window.location.hostname);
    } else {
      const value = `/en/${lang}`;
      document.cookie = `googtrans=${value}; path=/`;
      document.cookie = `googtrans=${value}; domain=${window.location.hostname}; path=/`;
    }

    // Refresh the page to trigger translation (optional)
    window.location.reload();
  };

  const deleteCookie = (name, path = '/', domain) => {
    document.cookie = `${name}=; path=${path}; ${
      domain ? `domain=${domain};` : ''
    } expires=Thu, 01 Jan 1970 00:00:01 GMT;`;
  };

  useEffect(() => {
    const countryCode = sessionStorage.getItem('gamesbox-country-code');
    const defaultLangSet = sessionStorage.getItem('default_lang_set');

    if (countryCode && !defaultLangSet) {
      const lowerCode = countryCode.toLowerCase();
      if (['fr', 'pl', 'de'].includes(lowerCode)) {
        setLanguage(lowerCode);
        sessionStorage.setItem('default_lang_set', true);
      }
    } else if (!countryCode) {
      fetch('https://dz5yc9ggwa4v9.cloudfront.net/Lambda/GetCountry')
        .then((response) => response.text())
        .then((country) => {
          const code = country.toLowerCase();
          sessionStorage.setItem('gamesbox-country-code', code);
          if (['fr', 'pl'].includes(code)) {
            setLanguage(code);
          }
        })
        .catch((err) => {
          console.warn('Failed to get country:', err);
        });
    }
  }, []);

  return (
    <div className="gtranslate_wrapper">
      <select
        className="custom_translate_dropdown"
        value={selectedLang}
        onChange={(e) => setLanguage(e.target.value)}
      >
         <option value="en" style={{display:'none'}}>English</option>
        <option value="en">English</option>
        <option value="de">German</option>
        <option value="ar">Arabic</option>
        <option value="fr">French</option>
        <option value="pl">Polish</option>
      </select>
    </div>
  );
};

export default GTranslateDropdown;
